import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { shouldPreserveReturnUrl } from '../../shared/utils/safe-return-url';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  public constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  public canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (!this.authService.isAuthenticated()) {
      this.navigateToLogin(state?.url ?? '/');
      return of(false);
    }
    return this.authService.validateSession().pipe(
      map(() => true),
      catchError(() => {
        this.navigateToLogin(state?.url ?? '/');
        return of(false);
      })
    );
  }

  private navigateToLogin(returnUrl: string): void {
    if (shouldPreserveReturnUrl(returnUrl)) {
      void this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl },
      });
      return;
    }
    void this.router.navigate(['/auth/login']);
  }
}
